import ListItem from "../List/ListItem";
import ListItemImage from "../List/ListItemImage";

type OwnProps = {
  id: number;
  pictureUrl?: string;
  title: string;
  description?: string;
  disabled: boolean;
  checked: boolean;
  currentInSubscription: boolean;
  onChange: $TSFixMeFunction;
  opacity?: number;
};

const defaultProps: Partial<OwnProps> = {
  pictureUrl: undefined,
  opacity: 1,
  description: "",
};

type Props = OwnProps & typeof defaultProps;

export function SubscriptionAssignedAssetsEditItem({
  id,
  pictureUrl,
  title,
  description,
  checked,
  onChange,
  disabled,
  opacity,
  currentInSubscription,
}: Props) {
  const handleOnClick = () => {
    if (!disabled) {
      onChange(id, currentInSubscription);
    }
  };

  return (
    <ListItem
      id={`asset-item-${id}`}
      image={pictureUrl ? <ListItemImage pictureUrl={pictureUrl} /> : undefined}
      icon={pictureUrl ? undefined : "icon-eh-device"}
      title={title}
      description={description}
      onClick={handleOnClick}
      actions={
        <div style={{ opacity }}>
          <input
            id={`asset-item-${id}-checkbox`}
            type="checkbox"
            className={checked ? "checked" : "unchecked"}
            checked={checked}
            onChange={handleOnClick}
            disabled={disabled}
          />
          <label
            className="checkbox-label"
            htmlFor={`asset-item-${id}-checkbox`}
          />
        </div>
      }
    />
  );
}

SubscriptionAssignedAssetsEditItem.defaultProps = defaultProps;

export default SubscriptionAssignedAssetsEditItem;
